import React, { useState } from "react"

import './styles.css';
import { AceiteDeTermos } from "./AceiteDeTermos";
import { usePrimeiroAgendamentoContext } from "./contexts/PrimeiroAgendamentoContext";
import { BoasVindas } from "./BoasVindas";
import { AgendarAtendimento } from "./AgendarAtendimento";

export const PrimeiroAgendamento: React.FC = () => {
    const { steps } = usePrimeiroAgendamentoContext()

    return (
        <div className='page-container'>
            {steps === 0 && <AceiteDeTermos />}
            {steps === 1 && <BoasVindas />}
            {steps === 2 && <AgendarAtendimento />}
        </div>
    )
}